import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
export const AdvancingSessionApi = {
  Paginated: {
    useQuery: (dto: server.dto.PaginatedAdvancingSessionInstruction, opts: UseQueryOptions<server.dto.ApiResponseWrapperWithRequest<server.dto.AdvancingSessionForListForInternalUser[], server.dto.ListAdvancingFilters>>) => useQuery({
      queryKey: ["AdvancingSession.Paginated", dto],
      queryFn: () => window.CoreApi.AdvancingSession.Paginated(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.PaginatedAdvancingSessionInstruction) => ["AdvancingSession.Paginated", dto]
  }, 
  GetSidePanelData: {
    useQuery: (advancingSessionId: number, opts: UseQueryOptions<server.dto.ApiResponseWrapper<server.dto.AdvancingSessionSidePanelData>>) => useQuery({
      queryKey: ["AdvancingSession.GetSidePanelData", advancingSessionId],
      queryFn: () => window.CoreApi.AdvancingSession.GetSidePanelData(advancingSessionId).then(r => r.data),
      ...opts
    }),
    getCacheKey: (advancingSessionId: number) => ["AdvancingSession.GetSidePanelData", advancingSessionId]
  }, 
  Create: {
    useQuery: (dto: server.dto.CreateAdvancingSessionInstruction, opts: UseQueryOptions<server.dto.ApiResponseWrapper<number>>) => useQuery({
      queryKey: ["AdvancingSession.Create", dto],
      queryFn: () => window.CoreApi.AdvancingSession.Create(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.CreateAdvancingSessionInstruction) => ["AdvancingSession.Create", dto]
  }, 
  ApproveFormRow: {
    useQuery: (instruction: server.dto.ApproveAdvancingFormRowInstruction, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["AdvancingSession.ApproveFormRow", instruction],
      queryFn: () => window.CoreApi.AdvancingSession.ApproveFormRow(instruction).then(r => r.data),
      ...opts
    }),
    getCacheKey: (instruction: server.dto.ApproveAdvancingFormRowInstruction) => ["AdvancingSession.ApproveFormRow", instruction]
  }, 
  DeclineFormRow: {
    useQuery: (dto: server.dto.DeclineAdvancingFormRowInstruction, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["AdvancingSession.DeclineFormRow", dto],
      queryFn: () => window.CoreApi.AdvancingSession.DeclineFormRow(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.DeclineAdvancingFormRowInstruction) => ["AdvancingSession.DeclineFormRow", dto]
  }, 
  RemoveFormRow: {
    useQuery: (dto: server.dto.RemoveAdvancingFormRowInstruction, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["AdvancingSession.RemoveFormRow", dto],
      queryFn: () => window.CoreApi.AdvancingSession.RemoveFormRow(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.RemoveAdvancingFormRowInstruction) => ["AdvancingSession.RemoveFormRow", dto]
  }, 
  PaginatedMessage: {
    useQuery: (dto: server.dto.PaginatedAdvancingMessageInstruction, opts: UseQueryOptions<server.dto.ApiResponseWrapper<server.dto.AdvancingMessage[]>>) => useQuery({
      queryKey: ["AdvancingSession.PaginatedMessage", dto],
      queryFn: () => window.CoreApi.AdvancingSession.PaginatedMessage(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.PaginatedAdvancingMessageInstruction) => ["AdvancingSession.PaginatedMessage", dto]
  }, 
  SendMessage: {
    useQuery: (dto: server.dto.SendAdvancingMessageInstruction, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["AdvancingSession.SendMessage", dto],
      queryFn: () => window.CoreApi.AdvancingSession.SendMessage(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.SendAdvancingMessageInstruction) => ["AdvancingSession.SendMessage", dto]
  }, 
  AddAdvancingParticipant: {
    useQuery: (dto: server.dto.AddParticipantToSessionInstruction, opts: UseQueryOptions<server.dto.ApiResponseWrapper<number>>) => useQuery({
      queryKey: ["AdvancingSession.AddAdvancingParticipant", dto],
      queryFn: () => window.CoreApi.AdvancingSession.AddAdvancingParticipant(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.AddParticipantToSessionInstruction) => ["AdvancingSession.AddAdvancingParticipant", dto]
  }, 
  DeleteParticipant: {
    useQuery: (advancingParticipantId: number, opts: UseQueryOptions<server.dto.ApiResponse>) => useQuery({
      queryKey: ["AdvancingSession.DeleteParticipant", advancingParticipantId],
      queryFn: () => window.CoreApi.AdvancingSession.DeleteParticipant(advancingParticipantId).then(r => r.data),
      ...opts
    }),
    getCacheKey: (advancingParticipantId: number) => ["AdvancingSession.DeleteParticipant", advancingParticipantId]
  }, 
  ListActivity: {
    useQuery: (dto: server.dto.PaginatedAdvancingActivityInstruction, opts: UseQueryOptions<server.dto.ApiResponseWrapper<server.dto.AdvancingSessionActivity[]>>) => useQuery({
      queryKey: ["AdvancingSession.ListActivity", dto],
      queryFn: () => window.CoreApi.AdvancingSession.ListActivity(dto).then(r => r.data),
      ...opts
    }),
    getCacheKey: (dto: server.dto.PaginatedAdvancingActivityInstruction) => ["AdvancingSession.ListActivity", dto]
  }, 

}
